@if (type === 'statement' || type === 'info-tag') {
    <span class="statement" [ngClass]="['statement_' + size]">{{ text }}</span>
}

@if (type === 'campaign') {
    <span class="text" [ngClass]="'text_' + size">{{ text }}</span>
}

@if (type === 'save' && amount) {
    <span class="text text-uppercase" [ngClass]="'text_' + size">{{ text }}</span>
    <span class="text-saving" [ngClass]="'text-saving_' + size">{{ amount }}%</span>
    <app-svg-icon iconName="dashed_circle"></app-svg-icon>
}

@if (type === 'retail-media') {
    <span class="text-retail-media" [ngClass]="'text_' + size">{{ text }}</span>
}
